import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { requireOperator } from "../auth/guard";
import type { Operator } from "../lib/api-types";

/** Route guard for /admin: signed-out visitors go to /login, signed-in non-admins to /app. */
export async function requireAdmin(queryClient: QueryClient): Promise<Operator> {
  const operator = await requireOperator(queryClient);
  if (!operator.isAdmin) {
    // TanStack Router requires throwing redirect() from beforeLoad.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/app" });
  }
  return operator;
}
